import { useMutation } from '@tanstack/react-query';
import { getAuthService } from '../ports/auth-service.registry';
import { backendAuthService } from '../services/backend-auth.service';
import { useAuthStore } from '../stores/authStore';
import type { AuthenticationResponse } from '../types/auth.types';

export function useGoogleLogin(): {
  googleLogin: (variables: void) => void;
  isLoading: boolean;
  error: Error | null;
  isSuccess: boolean;
} {
  const setUser = useAuthStore((state) => state.setUser);
  const setToken = useAuthStore((state) => state.setToken);

  const mutation = useMutation<AuthenticationResponse, Error, void>({
    mutationFn: async () => {
      const authService = getAuthService();
      await authService.loginWithGoogle();
      const token = await authService.getIdToken();
      if (!token) throw new Error('Failed to get Firebase token');
      return backendAuthService.authenticate(token);
    },
    onSuccess: (data) => {
      setUser(data.user);
      setToken(data.user.id);
    },
  });

  return {
    googleLogin: mutation.mutate,
    isLoading: mutation.isPending,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
  };
}
